"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLocation = formatLocation;
exports.formatWindowSize = formatWindowSize;
function formatLocation() {
    return {
        hash: window.location.hash,
        host: window.location.host,
        hostname: window.location.hostname,
        href: window.location.href,
        origin: window.location.origin,
        pathname: window.location.pathname,
        port: window.location.port,
        protocol: window.location.protocol,
        search: window.location.search,
    };
}
function formatWindowSize() {
    return {
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        width: document.body.clientWidth,
        height: document.body.clientHeight,
    };
}
exports.default = {};
